import React, { useEffect } from 'react';
import Header from './Header';
import HowItWorks from './HowItWorks';
import DesignQuilt from './DesignQuilt';
import Testimonials from './Testimonials';
import Statistics from './Statistics';
import Footer from './Footer';
import HeroSection from './HeroSection'; // Re-import HeroSection
import ImageSection from './ImageSection';
import AboutSection from './AboutSection';
import TawkChat from '../components/TawkChat';
import HotjarIntegration from '../components/HotjarIntegration'

const Home = () => {
  // Handle hash navigation on component mount and hash changes
  useEffect(() => {
    const handleHashNavigation = () => {
      const hash = window.location.hash.substring(1); // Remove the # symbol
      
      if (hash) {
        // Map hash values to element IDs
        const hashToIdMap = {
          'calculator': 'quilt-calculator',
          'how-it-works': 'how-nostai-works',
          'help': 'help-guide',
          'faq': 'help-guide'
        };
        
        const targetId = hashToIdMap[hash] || hash;
        
        // Delay to ensure the page is fully loaded, including iframe content
        setTimeout(() => {
          const element = document.getElementById(targetId);
          if (element) {
            const headerHeight = 100; // Approximate header height
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerHeight;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }, 500);
      }
    };

    // Handle initial load
    handleHashNavigation();

    // Handle hash changes (when navigating with hash links)
    window.addEventListener('hashchange', handleHashNavigation);

    // Cleanup
    return () => {
      window.removeEventListener('hashchange', handleHashNavigation);
    };
  }, []);

  return (
    <div className="flex flex-col items-center gap-10 w-full bg-[#F6E8E0]">
      <Header />
      <main className="w-full flex flex-col items-center gap-0 px-0 mx-0 py-0">
        <HotjarIntegration />

        {/* HTML Hero Section */}
        <div className="w-full">
          <iframe
            src="/hero-section.html"
            className="w-full border-0"
            style={{ 
              height: window.innerWidth < 768 ? '400px' : '600px', 
              minHeight: window.innerWidth < 768 ? '300px' : '500px' 
            }}
            title="NOSTAi Hero Section"
          ></iframe>
        </div>

        <div className="w-full flex flex-col items-center gap-0 px-0 mx-0 py-0">
          <HowItWorks />
          <DesignQuilt />
          <Testimonials />
          <Statistics />
          <ImageSection />
          <AboutSection />
          <TawkChat />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;